import { useState } from "react";

import { icon_pickup, icon_shipping } from "../images/icons";

interface DeliveryOption {
  id: string;
  headline: string;
  price: number;
  info1: string;
  info2: string;
  imageSrc: string;
  setPickup: boolean;
}

/**
 * Custom React hook to manage delivery options selection.
 *
 * Provides a list of available delivery options, the currently selected option,
 * and a setter to change the selected delivery option.
 *
 * @returns An object containing:
 * - `deliveryOptions`: Array of available delivery options.
 * - `selectedDelivery`: The currently selected delivery option object.
 * - `selectedDeliveryId`: The ID of the currently selected delivery option.
 * - `setSelectedDeliveryId`: Setter function to update the selected delivery option ID.
 */
export const useDeliveryOptions = () => {
  const [selectedDeliveryId, setSelectedDeliveryId] = useState<string>("pickup");

  const deliveryOptions: DeliveryOption[] = [
    {
      id: "shipping",
      headline: "Lieferung",
      price: 3.99,
      info1: "Zustellung innerhalb von 2-3 Werktagen",
      info2: "Kostenlos ab 33,50 € Bestellwert",
      imageSrc: icon_shipping,
      setPickup: false,
    },
    {
      id: "pickup",
      headline: "Abholung in Deiner Backhaus Häussler Filiale",
      price: 0,
      info1: "",
      info2: "",
      imageSrc: icon_pickup,
      setPickup: true,
    },
  ];

  const selectedDelivery = deliveryOptions.find(opt => opt.id === selectedDeliveryId);

  return {
    deliveryOptions,
    selectedDelivery,
    selectedDeliveryId,
    setSelectedDeliveryId,
  };
};
